import * as Sentry from "@sentry/react";
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { app, analytics } from './lib/firebase'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],
  tracesSampleRate: import.meta.env.MODE === "production" ? 0.2 : 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
  // Dev/HMR sessions were reporting transient mid-refactor errors as if they
  // were production bugs (0 real users, timestamps matching local edits) —
  // only report from production builds.
  enabled: import.meta.env.PROD && !!import.meta.env.VITE_SENTRY_DSN,
});

// Forward console logs to React Native WebView
(function () {
  const originalLog = console.log;
  console.log = function (...args) {
    originalLog(...args); // Keep original logging in the browser console
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: "log", data: args }));
    }
  };
})();

createRoot(document.getElementById('root')).render(
  // <StrictMode>
    <App />
  // </StrictMode>,
)
